import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const nav = useNavigate()

  useEffect(() => {
    // give some time for the permission locked routes to appear before we move them back to the root
    const timeout = setTimeout(() => {
      nav('/')
    }, 3000)

    return () => {
      clearTimeout(timeout)
    }
  }, [nav])

  return <div>Loading...</div>
}
